import React, { Fragment, useMemo, useState } from 'react';
import { getProducerType, sortOutcomeValues } from '../../../../../../utils/helpers';
import { useSelector } from 'react-redux';
import Deactive from './Deactive/Deactive';
import Active from './Active/Active';
import Specifiers from './Specifiers/Specifiers';
import {
    DEFAULT_MARKET_SPECIFIERS,
    MARKET_STATUSES,
} from '../../../../../../constants/defaultValues';

const Outcomes = ({ column, event }) => {
    const mainMarkets = useSelector(state => state.mainMarkets.data);

    const [selectedSpecifier, setSelectedSpecifier] = useState('');

    const getVisibleMarkets = () => {
        const visibleMarkets = [];
        const eventMarkets = event.markets || [];

        mainMarkets.forEach(market => {
            const { isSelected, selectedIndex, marketRefId, specifierCodes, outcomes } = market;

            if (isSelected) {
                const filteredMarkets = eventMarkets
                    .filter(m => m.marketRefId === marketRefId)
                    .map(m => ({ ...m, outcomes: sortOutcomeValues(m.outcomes) }));

                visibleMarkets.push({
                    id: market.id,
                    marketsList: filteredMarkets,
                    specifierCodes,
                    selectedColumnIndex: selectedIndex,
                    outcomesCount: outcomes.length,
                });
            }
        });

        return visibleMarkets;
    };

    const markets = useMemo(() => {
        return getVisibleMarkets();
    }, [event.markets, mainMarkets]);

    return (
        <tr>
            {markets.map(market => {
                if (market.selectedColumnIndex === column) {
                    const { marketsList, specifierCodes } = market;

                    if (marketsList.length > 0) {
                        if (specifierCodes.length === 0) {
                            const outcomes = marketsList[0].outcomes;

                            return outcomes.length ? (
                                <Active
                                    key={market.id}
                                    event={event}
                                    outcomes={outcomes}
                                    market={marketsList[0]}
                                />
                            ) : (
                                <Deactive outcomesCount={market.outcomesCount} />
                            );
                        } else {
                            const filteredMarkets = marketsList.filter(m => m.specifiers);

                            const selectedSpecifierMarket =
                                filteredMarkets.find(m => m.id === selectedSpecifier) ||
                                filteredMarkets.find(
                                    m =>
                                        m.status !== MARKET_STATUSES.deactivated &&
                                        m.specifiers.find(
                                            s =>
                                                Number(s.value) ===
                                                DEFAULT_MARKET_SPECIFIERS[event.sportTypeRefId]?.[
                                                    m.marketRefId
                                                ]?.[getProducerType(event.live)]
                                        )
                                ) ||
                                filteredMarkets.find(
                                    m => m.status !== MARKET_STATUSES.deactivated
                                ) ||
                                filteredMarkets[0];

                            return (
                                <Fragment key={market.id}>
                                    {selectedSpecifierMarket ? (
                                        <Specifiers
                                            specifiers={specifierCodes}
                                            marketsList={filteredMarkets}
                                            setSelectedSpecifier={setSelectedSpecifier}
                                            selectedSpecifierMarket={selectedSpecifierMarket}
                                        />
                                    ) : (
                                        <Deactive outcomesCount={specifierCodes.length} />
                                    )}
                                    {selectedSpecifierMarket?.outcomes.length > 0 ? (
                                        <Active
                                            event={event}
                                            outcomes={selectedSpecifierMarket.outcomes}
                                            market={selectedSpecifierMarket}
                                        />
                                    ) : (
                                        <Deactive outcomesCount={market.outcomesCount} />
                                    )}
                                </Fragment>
                            );
                        }
                    } else {
                        return (
                            <Deactive
                                key={market.id}
                                outcomesCount={market.outcomesCount + market.specifierCodes.length}
                            />
                        );
                    }
                } else {
                    return null;
                }
            })}
        </tr>
    );
};

export default Outcomes;
